jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
  var QueryString = (new URL(location.href)).searchParams.get('color');
  
 // setTimeout(function() {
  //$("."+QueryString).trigger("click");
 //   },100);
  console.log(QueryString);
  $(document).ready(function(){
    $(document).ready(checkContainerr);

function checkContainerr() {
  if($("."+QueryString).is(':visible')){ //if the container is visible on the page
    console.log("visible");
    setTimeout(function() {
   $("."+QueryString).trigger("click");
      },200);
  } else {
    console.log("not found");
    setTimeout(checkContainerr, 50); //wait 50 ms, then try again
    
  }
}
    console.log("working js")
  })
  // $(document).on("click", "a.t4s-pr-item-btn.t4s-pr-quickview", function(){
  //   console.log("quick view clicked");
  //   var getColor = $(this).parents(".t4s-product.t4s-pr-grid").attr("color-to-select");
  //   if ( getColor != "" )
  //   {
  //     setTimeout(function(){
  //   if( $(".t4s-modal.t4s-modal--is-active").is(":visible") )
  //   {
  //     $(".t4s-swatch__option.is-t4s-style__color.is-t4s-name__color").find(".t4s-swatch__item[title='"+getColor+"']").trigger("click")
  //   }
  //     }, 2000);
  //   }
  //   else if ($(this).parents(".t4s-product.t4s-pr-grid").find("span.t4s-pr-color__item").hasClass("is-swatch--selected"))
  //   {
  //     getColor = $(this).parents(".t4s-product.t4s-pr-grid").find("span.t4s-pr-color__item.is-swatch--selected span.t4s-pr-color__name").text();
  //       setTimeout(function(){
  //   if( $(".t4s-modal.t4s-modal--is-active").is(":visible") )
  //   {
  //     $(".t4s-swatch__option.is-t4s-style__color.is-t4s-name__color").find(".t4s-swatch__item[title='"+getColor+"']").trigger("click")
  //   }
  //     }, 2000);
  //   }
  //   // else 
  //   // {
  //   //   getColor = $(this).parents(".t4s-product.t4s-pr-grid").find("span.t4s-pr-color__item.t4s-tooltip-actived:first-child span.t4s-pr-color__name").text();
  //   //     setTimeout(function(){
  //   // if( $(".t4s-modal.t4s-modal--is-active").is(":visible") )
  //   // {
  //   //   $(".t4s-swatch__option.is-t4s-style__color.is-t4s-name__color").find(".t4s-swatch__item[title='"+getColor+"']").trigger("click")
  //   // }
  //   //   }, 2000);
  //   // }
    
  // })
$(document).on("click", "a.t4s-pr-item-btn.t4s-pr-quickview", function () {
    console.log("Quick view clicked");
    var thiss = $(this);
    var getColor = $(this).parents(".t4s-product.t4s-pr-grid").attr("color-to-select");

    function selectColor() {
        if ($(".t4s-modal.t4s-modal--is-active").is(":visible")) {
            if (getColor) {
                $(".t4s-swatch__option.is-t4s-style__color.is-t4s-name__color")
                    .find(".t4s-swatch__item[title='" + getColor + "']")
                    .trigger("click");
                clearInterval(interval); // Stop checking once color is selected
            } else if (thiss.parents(".t4s-product.t4s-pr-grid").find("span.t4s-pr-color__item").hasClass("is-swatch--selected")) {
                getColor =thiss
                    .parents(".t4s-product.t4s-pr-grid")
                    .find("span.t4s-pr-color__item.is-swatch--selected span.t4s-pr-color__name")
                    .text();
                $(".t4s-swatch__option.is-t4s-style__color.is-t4s-name__color")
                    .find(".t4s-swatch__item[title='" + getColor + "']")
                    .trigger("click");
                clearInterval(interval); // Stop checking once color is selected
            }
        }
    }

    // Continuously check every 500ms if the modal is visible
    var interval = setInterval(selectColor, 50);
});
 $(document).on("click", "span.t4s-pr-color__item", function(){
   var getVal = $(this).find(".t4s-pr-color__name").text();
   getVal = getVal.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
   console.log(getVal)
   var href= $(this).parents(".t4s-product").find("a.t4s-full-width-link").attr("href");
   href = href.split('?')[0]
   console.log(href)
   $(this).parents(".t4s-product").find("a").attr("href",href+"?color=bg_color_"+getVal)
   
 })
  $(document).on("mouseenter", "span.t4s-pr-color__item", function(){
   var getVal = $(this).find(".t4s-pr-color__name").text();
   getVal = getVal.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
   console.log(getVal)
   var href= $(this).parents(".t4s-product").find("a.t4s-full-width-link").attr("href");
   href = href.split('?')[0]
   console.log(href)
   $(this).parents(".t4s-product").find("a").attr("href",href+"?color=bg_color_"+getVal)
}).mouseleave(function() {
   // $(this).hide();
});
});


$(document).on("click", ".custom-size-button", function(e){
  e.preventDefault();
  e.stopPropagation();
    $("body").addClass("popup-hide-scroll");
    $(this).addClass("active");
    $(".custom-size-main-wrapper").find("#custom-size-chart").show();
    $(".custom-size-main-wrapper").find(".custom-size-overlay").show();
    $(".custom-size-main-wrapper").addClass("custom-size-active");
});

 $(document).on('click', '.custom-size-overlay', function(){
    $("body").removeClass("popup-hide-scroll");
    $(".custom-size-main-wrapper").find("#custom-size-chart").hide();
    $(".custom-size-main-wrapper").find(".custom-size-overlay").hide();
    $(".custom-size-main-wrapper").removeClass("custom-size-active");
 });

    $(document).on('click', '.custom-size-close', function(){
    $("body").removeClass("popup-hide-scroll");
    $(".custom-size-main-wrapper").find("#custom-size-chart").hide();
    $(".custom-size-main-wrapper").find(".custom-size-overlay").hide();
    $(".custom-size-main-wrapper").removeClass("custom-size-active");
  });